import React, { Component } from 'react'
import PropTypes from 'prop-types'


class InterestOption extends Component {
  static propTypes = {
    data: PropTypes.any.isRequired,
    onClick: PropTypes.any.isRequired,
    isSelected: PropTypes.bool.isRequired,
  }

  render() {
    const { data: { name, title }, onClick, isSelected } = this.props
    return (
      <button onClick={() => onClick(name)}
        className={`btn ${isSelected ? 'btn-primary' : 'btn-outline-primary'}`}
        style={{
          minWidth: 200,
          borderRadius: 4,
          cursor: 'pointer',
          margin: '10px 10px',
          display: 'inline-block',
          color: isSelected ? 'white' : 'black',
          border: '1px solid lightgrey',
          padding: '10px 5px'
        }}
      >
        {title}
      </button>
    )
  }
}
export default InterestOption



// WEBPACK FOOTER //
// ./src/components/ui/InterestSelector/InterestOption.js